import { render, staticRenderFns } from "./BdSet.vue?vue&type=template&id=5ba28cd7&scoped=true&"
import script from "./BdSet.vue?vue&type=script&lang=js&"
export * from "./BdSet.vue?vue&type=script&lang=js&"
import style0 from "./BdSet.vue?vue&type=style&index=0&id=5ba28cd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba28cd7",
  null
  
)

export default component.exports